import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from './spzaComponent';
class Animation extends SpzaComponent {
    renderImpl() {
        return this.props.isCircular ? /*#__PURE__*/ _jsxs("div", {
            className: "c-progress f-indeterminate-local f-progress-small",
            role: "progressbar",
            "aria-valuetext": "Loading...",
            tabIndex: 0,
            "aria-label": "indeterminate local small progress bar",
            children: [
                /*#__PURE__*/ _jsx("span", {}),
                /*#__PURE__*/ _jsx("span", {}),
                /*#__PURE__*/ _jsx("span", {}),
                /*#__PURE__*/ _jsx("span", {}),
                /*#__PURE__*/ _jsx("span", {})
            ]
        }) : /*#__PURE__*/ _jsxs("div", {
            className: "c-progress f-indeterminate-regional",
            role: "progressbar",
            "aria-valuetext": "Loading...",
            tabIndex: 0,
            children: [
                /*#__PURE__*/ _jsx("span", {
                    className: "aniDot"
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: "aniDot"
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: "aniDot"
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: "aniDot"
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: "aniDot"
                })
            ]
        });
    }
}
export { Animation as default };
Animation.contextTypes = {
    renderErrorModal: PropTypes.func
};
